import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {listenerMiddleware} from 'src/models';

import {TFilters} from './definitions';

const initialState = () => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.CHANNELS_FILTERS);
  const rememberedFiltersSupport = sessionStorage.getItem(EStorageKeys.CHANNELS_FILTERS_SUPPORT);

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
    supportFilters: rememberedFiltersSupport ? JSON.parse(rememberedFiltersSupport) : {},
  };
};

const channelsSlice = createSlice({
  name: 'channels',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TFilters>) {
      state.filters = action.payload;
    },
    setSupportFilters(state, action: PayloadAction<TFilters>) {
      state.supportFilters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction, setSupportFilters: setSupportFiltersAction} =
  channelsSlice.actions;
export const selectFilters = (state: TRootState) => state.channels.filters as TFilters;
export const selectSupportFilters = (state: TRootState) =>
  state.channels.supportFilters as TFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(EStorageKeys.CHANNELS_FILTERS, JSON.stringify(action.payload));
  },
});

listenerMiddleware.startListening({
  actionCreator: setSupportFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(EStorageKeys.CHANNELS_FILTERS_SUPPORT, JSON.stringify(action.payload));
  },
});

export default channelsSlice.reducer;
